import Vue from "vue";
import $ from 'jquery'
import { Component, Prop } from "vue-property-decorator";
import { ActivityPriority, ListItem } from "../../backend/backendapi";


@Component({
    name: 'PrioritySelectModal'
})
export default class PrioritySelectModal extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    available!: ActivityPriority[];
    @Prop({ required: true })
    selected!: ActivityPriority | null;

    openModal(): void {
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private close(): void {

    }

    private click(item: ListItem): void {
        this.$emit('selected', (this.selected && this.selected.id) === item.id ? null : item);
    }
}